import { render, staticRenderFns } from "./OidcSignOutCallback.vue?vue&type=template&id=842c3160"
import script from "./OidcSignOutCallback.vue?vue&type=script&lang=js"
export * from "./OidcSignOutCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports